import { combineReducers } from 'redux';

import { Reducer } from '../../../types';
import { MediaViewerState, MediaViewerAction } from '../types';
import { setDocumentDownloadUrl } from '../utils';
import {
  setOpenMediaViewer,
  setCurrentIndexMediaViewer,
  setCurrentDocumentPageMediaViewer,
  setMediaList,
  getDocumentPageListRequest,
  getDocumentPageListSuccess,
  getDocumentPageListFail,
  getDocumentDownloadUrlRequest,
  getDocumentDownloadUrlSuccess,
  getDocumentDownloadUrlFail,
  shouldToggleVideoPlayerInMediaViewer,
  resetToggleVideoPlayerInMediaViewer,
} from '../actions';

type ReducerOf<T extends keyof MediaViewerState> = Reducer<MediaViewerState, MediaViewerAction, T>;

const open: ReducerOf<'open'> = (state = false, action) => {
  switch (action.type) {
    case setOpenMediaViewer.type:
      return action.payload;

    default:
      return state;
  }
};

const currentIndex: ReducerOf<'currentIndex'> = (state = 0, action) => {
  switch (action.type) {
    case setCurrentIndexMediaViewer.type:
      return action.payload;

    default:
      return state;
  }
};

const currentDocumentPage: ReducerOf<'currentDocumentPage'> = (state = 1, action) => {
  switch (action.type) {
    case setCurrentDocumentPageMediaViewer.type:
      return action.payload;
    default:
      return state;
  }
};

const mediaList: ReducerOf<'mediaList'> = (state = [], action) => {
  switch (action.type) {
    case setMediaList.type:
      return action.payload;

    case getDocumentDownloadUrlSuccess.type:
      return setDocumentDownloadUrl(state, action.payload);

    default:
      return state;
  }
};

const documentPageList: ReducerOf<'documentPageList'> = (state = [], action) => {
  switch (action.type) {
    case getDocumentPageListRequest.type:
      return [];

    case getDocumentPageListSuccess.type:
      return action.payload;

    default:
      return state;
  }
};

const loading: ReducerOf<'loading'> = (state = false, action) => {
  switch (action.type) {
    case getDocumentPageListRequest.type:
    case getDocumentDownloadUrlRequest.type:
      return true;

    case getDocumentPageListSuccess.type:
    case getDocumentDownloadUrlSuccess.type:
    case getDocumentPageListFail.type:
    case getDocumentDownloadUrlFail.type:
      return false;

    default:
      return state;
  }
};

const shouldRunVideoInMediaViewer: ReducerOf<'shouldRunVideoInMediaViewer'> = (state = false, action) => {
  switch (action.type) {
    case shouldToggleVideoPlayerInMediaViewer.type:
      return true;

    case resetToggleVideoPlayerInMediaViewer.type:
      return false;

    default:
      return state;
  }
};

export default combineReducers<MediaViewerState>({
  open,
  mediaList,
  documentPageList,
  currentIndex,
  currentDocumentPage,
  loading,
  shouldRunVideoInMediaViewer,
});
